export const CACHE_ROUTE = {
  TITLE: "Cache",
  KEY: "cache",
  ABSOLUTE_PATH: "/cache",
  PARENT_PATH: "cache/*",
};
